import { message } from "antd";
import { m } from "framer-motion";
import { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

const PrivateRoute = () => {
  const token = localStorage.getItem("nzanzi");
  const navigate = useNavigate();
  useEffect(() => {
    if (!token) {
      // message.error("Authentication failed. Please try again.");
      setTimeout(() => {
        localStorage.clear();
        navigate("/Authpage");
      }, 500);
    }
  }, [token]);

  return <Outlet />;
};

export default PrivateRoute;
